import { PagingUi } from '@/components/TableData/TableDataUi';
import { PageFields } from '@/data/api/model/page';

export const responseToPagingUi = (input: Required<PageFields>) => {
  const ret: PagingUi = {
    pageCount: Math.ceil(input.total / input.limit),
    currentPage: input.page,
  };
  return ret;
};
